/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export type AdminChannelBody = {
  name: string;
  description: string;
  isPublic: boolean;
  allowMessages: boolean;
  allowImages: boolean;
  enableMeeting: boolean;
};

export class AdminChannels<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  list = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/List`, method: "GET", secure: true, ...params });
  detail = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/Detail/${id}`, method: "GET", secure: true, ...params });
  create = (data: AdminChannelBody, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  update = (id: string, data: AdminChannelBody, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/${id}`, method: "PUT", body: data, secure: true, type: ContentType.Json, ...params });
  remove = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/${id}`, method: "DELETE", secure: true, ...params });
  addMember = (id: string, data: { userId: string; role: number }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/${id}/Member`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  addMembersFromGroup = (id: string, data: { groupId: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/${id}/Members/FromGroup`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  setMemberRole = (id: string, userId: string, data: { userId: string; role: number }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/${id}/Member/${userId}`, method: "PUT", body: data, secure: true, type: ContentType.Json, ...params });
  removeMember = (id: string, userId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminChannels/${id}/Member/${userId}`, method: "DELETE", secure: true, ...params });
}
